module.exports = __webpack_public_path__ + "img/check-circle.95fc0065.svg";